import PageContainer from "../../Components/Page/PageContainer";
import UploadToolRow from "./LinkingToolComponents/UploadTool";

const SpotifyPodcastUploader = () => {


  return (
    <PageContainer
      HomeMenuBarprops={{
        title: "Spotify Podcast Uploader",
      }}
    >
        <UploadToolRow />
    </PageContainer>
  );
};

export default SpotifyPodcastUploader;
